import { metadata,
	FEATURE_EDITO_CITATION,
	FEATURE_EDITO_CITATION_AUTHOR
} from "lacinetek-common/src/metadata"
import { useTranslation } from "lib/i18n/translation"

export default ({treasure, loading}) => {
	const { c } = useTranslation("common")
	const citation = metadata(treasure, FEATURE_EDITO_CITATION)
	if (!citation || citation == "") return null

	return (
		<section>
			<h2 className="section-title icon-eye">{c("edito")}</h2>
			<div className={`quote large ${loading ? "skeleton" : ""}`}>
				<blockquote>{metadata(treasure, FEATURE_EDITO_CITATION)}</blockquote>
				<span className="source">{metadata(treasure, FEATURE_EDITO_CITATION_AUTHOR)}</span>
			</div>
			<div className={`columnizer ${loading ? "skeleton" : ""}`} data-columns="3" dangerouslySetInnerHTML={{__html: treasure.descriptionShort}} />
		</section>
	)
}
